
const setPostCode = (postcode) => {
    // Save postcode in local storage
      localStorage.setItem('postcode', postcode);
        updatePostCode(postcode);
 }

const removePostCode = () => {
  localStorage.removeItem('postcode');
  updatePostCode();
}
 const getPostCode = () => {
     // Get postcode from local storage
     return localStorage.getItem('postcode');
 }

 const setTimeWindows = (timeWindows) => {
     // Save postcode in local storage
     localStorage.setItem('timeWindows', JSON.stringify(timeWindows));
 }
 const getTimeWindows = () => {
     // Get postcode from local storage
     return JSON.parse(localStorage.getItem('timeWindows'));
 }
 const validPostcodeMessage = (postcode) => `Your delivery postcode is set to ${postcode}`;
 const updatePostCode = (postcode) => {


    document.querySelectorAll('.postcode-checker').forEach(postcodeChecker => {
        if(postcode == null || postcode == undefined) {
            const message = `Sorry, we don't deliver to that area`;
            postcodeChecker.querySelector('.postcode-result-message').innerHTML = message;
            postcodeChecker.querySelector('.postcode-checker-result').classList.remove('hidden');
            postcodeChecker.querySelector('.postcode-result--signup').classList.remove('hidden');
            postcodeChecker.querySelector('.postcode-checker-form').classList.add('hidden');
            document.querySelectorAll('.delivery-postcode').forEach(el => el.innerHTML = '');

        } else {
            postcodeChecker.querySelector('.postcode-result-message').innerHTML = validPostcodeMessage(postcode);
            postcodeChecker.querySelector('.postcode-checker-result').classList.remove('hidden');
            postcodeChecker.querySelector('.postcode-checker-form').classList.add('hidden');
            postcodeChecker.querySelector('.postcode-result--signup').classList.add('hidden');
            document.querySelectorAll('.delivery-postcode').forEach(el => el.innerHTML = postcode);
        }
    })

 }

 window.addEventListener('DOMContentLoaded', (ev) => {
        const postcode = getPostCode();
        if (postcode) {
            updatePostCode(postcode);
        } else {
        }
 })


